module.exports = __webpack_public_path__ + "static/img/image011.1e3d827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image011.png
// module id = 3UZL
// module chunks = 1